import {OrderTypes} from "@/constants";

export function setSortParamsToSearchParams(
    sortArray,
    searchParams,
) {
    if (sortArray[0]?.id) {
        searchParams.set('sortKey', sortArray[0].id)
        searchParams.set(
            'sortDirection',
            sortArray[0]?.desc ? OrderTypes.Desc : OrderTypes.Asc,
        )
    } else {
        searchParams.delete('sortKey')
        searchParams.delete('sortDirection')
    }
}
